import { getFetchProperties } from 'tinymce-data/api/Properties';
import { getPropertiesLabelsMap, createPropertiesLabelsMap } from 'rich-text-lib/utils/buildProperties';
let propertiesPromise = null;
export const initProperties = (editor, propertiesConfig, invalidateCache = false) => {
  const {
    apiClient
  } = editor.settings;
  const cachedPropertiesLabelsMap = getPropertiesLabelsMap(propertiesConfig);
  if (cachedPropertiesLabelsMap) {
    propertiesPromise = Promise.resolve(cachedPropertiesLabelsMap);
  } else {
    const fetchProperties = getFetchProperties(apiClient, invalidateCache);
    propertiesPromise = createPropertiesLabelsMap(fetchProperties, propertiesConfig, invalidateCache);
  }
  return propertiesPromise;
};